import { Coordination } from './Coordination';
import { CoordinationCard as ServerCoordinationCard } from 'server/models/CoordinationCard';
import { CoordinationCardStatus } from 'data/models/CoordinationCardStatus';
import { CoordinationCardStatuses } from 'data/models/CoordinationCardStatuses';
import { CoordinationProvider } from './CoordinationProvider';

export * from 'server/models/CoordinationCard';

/** A C-Card or C-Card-like object that can be sorted via `CoordinationCard.DisplayOrder`. */
export interface SupportsCCardDisplayOrder {
    Id() : number;
    Coordination() : Coordination | null;
    Provider() : CoordinationProvider | null;
}

export interface SupportsCCardStatusLabel {
    Coordination() : Coordination | null;
    StatusId() : number;
    Status() : CoordinationCardStatus | null;
}

export class CoordinationCard extends ServerCoordinationCard implements SupportsCCardDisplayOrder {
    /** A comparator function for two C-Cards (or C-Card-like objects) belonging to the same milestone date. */
    static DisplayOrder(ccard1 : SupportsCCardDisplayOrder, ccard2 : SupportsCCardDisplayOrder) {
        let coord1 : Coordination | null,
            coord2 : Coordination | null,
            provider1 : CoordinationProvider | null,
            provider2 : CoordinationProvider | null;
        return (
            (coord1 = ccard1.Coordination()) ?
                (coord2 = ccard2.Coordination()) ?
                    coord1 === coord2 ?
                        // If C-Cards have the same Coordination, sort by Provider.
                        (provider1 = ccard1.Provider()) ?
                            (provider2 = ccard2.Provider()) ?
                                provider1 === provider2 ?
                                    // If C-Cards also have the same Provider, fallback to sorting by C-Card
                                    // Id for a deterministic sort.
                                    ccard1.Id() - ccard2.Id() :
                                    // If providers are distinct, sort by CoordinationProvider.DisplayOrder...
                                    CoordinationProvider.DisplayOrder(provider1, provider2) :
                                -1 /* Sort C-Cards w/ missing Provider last among C-Cards for that Coordination */ :
                            ccard2.Provider() ?
                                1 /* Sort C-Cards w/ missing Provider last among C-Cards for that Coordination */ :
                                0 :
                        // If coordinations are distinct, sort by Coordination.DisplayOrder...
                        Coordination.DisplayOrder(coord1, coord2) :
                    -1 /* Sort C-Cards w/ missing Coordination last among C-Cards for this milestone date */ :
                ccard2.Coordination() ?
                    1 /* Sort C-Cards w/ missing Coordination last among C-Cards for this milestone date */ :
                    0
        );
    }

    EffectiveStatusLabel(bypassAltPendingLabel? : boolean) {
        return CoordinationCard.EffectiveStatusLabelImpl(this, bypassAltPendingLabel);
    }

    static EffectiveStatusLabelImpl(ccard : SupportsCCardStatusLabel, bypassAltPendingLabel : boolean | undefined) {
        return bypassAltPendingLabel && ccard.StatusId() === CoordinationCardStatuses.Pending ?
            ccard.Status()?.DefaultLabel() ??
                null :
            ccard.Coordination()?.AltStatusLabels().find(l => l.StatusId() === ccard.StatusId())?.Label() ??
                ccard.Status()?.DefaultLabel() ??
                null;
    }
}



// WEBPACK FOOTER //
// ./data/models/CoordinationCard.ts